import Vue from 'vue';
import VueRouter from 'vue-router';
import main from "../main.js";

Vue.use(VueRouter);

const scrollBehavior = (to, from, savedPosition) => {

  return new Promise((resolve) => {

    main.$root.$once("triggerScroll", () => {
      if (savedPosition) {
        resolve( { ...savedPosition, behavior: 'smooth'});
      } else if (to.hash) {
        resolve( { selector: to.hash, behavior: 'smooth' });
      } else {
        resolve({ x: 0, y: 0 });
      }

    });


  });

};

const routes = [

    // redirects to /katalog
    // { path: '/catalog', redirect: '/katalog'},

    // APOTHEKEN
    // -------------------------------------------------------------------------
    { path: '/apotheken/', name: 'apotheken', component: view('apotheken/Apotheken'), meta: { suitableDefaultRoute: true, isParent: true, keepAlive: false } },
    { path: '/apotheken/apotheke-:siteID', name: 'apotheke', component: view('apotheken/Apotheke') },
    { path: '/apotheken/history', redirect: '/apotheken/aenderungshistorie' },
    { path: '/apotheken/aenderungshistorie', name: 'apoHistory', component: view('Logs') },
    { path: '/apotheken/apotheke-:siteID/print/', name: 'printPharmacy', component: view('apotheken/printPharmacy'), meta: { isPrintView: true } },

    // APOPOINT
    // -------------------------------------------------------------------------
    { path: '/apopoint/', name: 'apopoint', redirect: { name: 'apopoints'} },
    { path: '/apopoint/',  name: 'apoApopoint', redirect: { name: 'apoCMS'} },
    { path: '/apopoint/apopoint-seiten', name: 'apopoints', component: view('apotheken/Apopoints'), meta: { suitableDefaultRoute: true, isParent: true, keepAlive: false } },
    { path: '/apopoint/apopoint-seiten/apotheke-:siteID', name: 'apopointDetail', component: view('apotheken/Apotheke') },
    { path: '/apopoint/pim/marken', name: 'primBrands', component: view('pim/brands/Index'), meta: { suitableDefaultRoute: true, isParent: true } },
    { path: '/apopoint/pim/marken/:id', name: 'pimBrandDetail', component: view('pim/brands/BrandDetail') },
    { path: '/apopoint/pim/produkte', name: 'pimProducts', component: view('pim/Products'), meta: { suitableDefaultRoute: true, isParent: true } },

    { path: '/apopoint/pim/produkte/neu', name: 'pimProductNew', component: view('pim/Product'), redirect: { name: 'pimProductNewProduct' },
        children: [
            { path: '', name: 'pimProductNewProduct', components: { "PIM-PRODUCT-TAB-DETAIL": view('pim/Product-Tab-Detail') }}
        ]
    },

    { path: '/apopoint/pim/produkte/produkt-:id', name: 'pimProduct', component: view('pim/Product'), redirect: { name: 'pimProductDetail' },
      children: [
          { path: 'details', name: 'pimProductDetail', components: { "PIM-PRODUCT-TAB-DETAIL": view('pim/Product-Tab-Detail') }},
          { path: 'pharmacies', name: 'pimProductPharmacyInfo', components: { "PIM-PRODUCT-TAB-PHARMACY_INFO": view('pim/Product-Tab-PharmacyInfo') }, meta: { transition: 'none' }},
          { path: 'logs', name: 'pimProductLogs', components: { "PIM-PRODUCT-TAB-LOGS": view('pim/Product-Tab-Logs') }}
      ]
    },


    { path: '/apopoint/pim/aktionen', name: 'pimCampaigns', component: view('pim/campaigns/Campaigns'), meta: { suitableDefaultRoute: true, isParent: true } },
    { path: '/apopoint/pim/aktionen/:id', name: 'pimCampaignsDetail', component: view('pim/campaigns/CampaignsDetail') },

    { path: '/apopoint/pim/produkt-gruppen', name: 'pimProductGroups', component: view('pim/ProductGroups'), meta: { suitableDefaultRoute: true, isParent: true } },
    { path: '/apopoint/pim/produkt-gruppen/new', name: 'pimProductGroupsNew', component: view('pim/ProductGroupsDetail') },
    { path: '/apopoint/pim/produkt-gruppen/:id', name: 'pimProductGroupsDetail', component: view('pim/ProductGroupsDetail') },
    {
      path: '/apopoint/pim/einstellungen',
      name: 'pimSettings',
      component: view('pim/settings/Index'),
      redirect: { name: 'pimSettingsSortiment'},
      meta: { suitableDefaultRoute: true },
      children: [
        { path: 'sortiment', name: 'pimSettingsSortiment', components: { "PIM-SETTINGS-TAB-SORTIMENT": view('pim/settings/tab-sortiment') }},
        { path: 'shopix', name: 'pimSettingsShopix', components: { "PIM-SETTINGS-TAB-SHOPIX": view('pim/settings/tab-shopix') }},
        { path: 'shopix', name: 'pimSettingsSisix', components: { "PIM-SETTINGS-TAB-SISIX": view('pim/settings/tab-sisix') }}
      ]
    },
    {
      path: '/apopoint/control-center',
      name: 'apopointCC',
      component: view('apotheken/controlCenter/Index'),
      redirect: { name: 'apopointCCStart'},
      meta: { suitableDefaultRoute: true },
      children: [
        { path: '1', name: 'apopointCCStart', components: { "APOPOINT-CC-TAB-START": view('apotheken/controlCenter/tab-plugins') }},
        { path: '2', name: 'apopointCC2', components: { "PIM-SETTINGS-TAB-SHOPIX": view('pim/settings/tab-shopix') }},
        { path: '3', name: 'apopointCC3', components: { "PIM-SETTINGS-TAB-SISIX": view('pim/settings/tab-sisix') }}
      ]
    },

    // SANOVA DOWNLOAD PLATFORM
    // -------------------------------------------------------------------------
    { path: '/sanova-asset-manager/', name: 'sanovaAssetManager', redirect: { name: 'sam-assets'} },
    { path: '/sanova-asset-manager/assets', name: 'sam-assets', component: view('sanovaAssetManager/Index'), meta: { suitableDefaultRoute: true, isParent: true } },
    { path: '/sanova-asset-manager/asset-groups', name: 'sam-asset_groups', component: view('sanovaAssetManager/asset-groups/Index'), meta: { suitableDefaultRoute: true, isParent: true } },


    // APOTHEKEN KATALOG
    // -------------------------------------------------------------------------
    { path: '/katalog/', component: view('catalog/Index'),

      children: [

        { path: '',  name: 'catalog', component: view('catalog/Catalog'), meta: { suitableDefaultRoute: true, title: 'Cluster', isParent: true } },
        { path: 'apotheken', name: 'catalogPharmacies', component: view('catalog/Pharmacies'), meta: { suitableDefaultRoute: true} },
        { path: 'apotheken/apotheke-:siteID', name: 'catalogPharmacyDetail', component: view('catalog/Pharmacy') },
        { path: 'neu', name: 'catalogPageNew', component: view('catalog/CatalogPage') },
        { path: 'spezial/:type-:pageID', name: 'catalogPageSpecial', component: view('catalog/CatalogPageSpecial') },
        { path: 'seite-:page1ID-:page2ID', name: 'catalogPage', component: view('catalog/CatalogPage') },
        { path: 'seite-:page1ID-:page2ID/aenderungshistorie', name: 'catalogPageChangeLog', component: view('Logs') },

        { path: 'pageElement', name: 'catalogPageElementNew', component: view('catalog/CatalogPageElement') },
        // { path: '/katalog/pageElement-:catalogPageElementID', name: 'catalogPageElement', component: view('catalog/CatalogPageElement') },
        { path: 'pageElement-:id', name: 'catalogPageElement', component: view('catalog/CatalogPageElement') },

        { path: 'reminder', name: 'catalogReminder', component: view('Reminder'), meta: { isParent: true } },
        { path: 'aenderungshistorie', name: 'catalogChangeLog', component: view('Logs') },

        { path: 'produkte', component: view('products/Index'),
          children: [
            { path: '', name: 'produkte', component: view('products/Products'), meta: { suitableDefaultRoute: true, isParent: true, keepAlive: false }},
            { path: 'neu', name: 'productNew', component: view('products/Product') },
            { path: 'produkt-:id', name: 'product', component: view('products/Product') },
            { path: 'produkt-:productID/history', name: 'productHistory', component: view('Logs') },

            { path: 'history', redirect: '/aenderungshistorie' },
            { path: 'aenderungshistorie', name: 'productsHistory', component: view('Logs') },
            { path: 'reminder', name: 'productsReminder', component: view('Reminder'), meta: { isParent: true } },

            { path: 'print', name: 'x', component: view('products/PrintProducts'), meta: { isPrintView: true } },
            { path: 'print-:productID', name: 'printProduct', component: view('products/PrintProducts'), meta: { isPrintView: true } },
            { path: 'print/:filter', name: 'z', component: view('products/PrintProducts'), meta: { isPrintView: true } },
          ]
        },

        { path: 'monitoring/', name: 'monitoring', component: view('monitoring/Monitoring'), meta: { suitableDefaultRoute: true, isParent: true } },

        /*
        { path: 'hersteller/', name: 'settingsManufacturers', component: view('settings/manufacturers/Manufacturers'), meta: { isParent: true },
          children: [
            { path: 'hersteller-:manufacturerID', name: 'settingsManufacturersEdit', component: view('settings/manufacturers/Manufacturer') },
            { path: 'neu', name: 'settingsManufacturersNew', component: view('settings/manufacturers/Manufacturer') },
          ]
        },

        { path: 'rubriken', name: 'settingsSections', component: view('settings/sections/Sections'), meta: { isParent: true },
          children: [
            { path: 'rubrik-:sectionID', name: 'settingsSectionsEdit', component: view('settings/sections/Section') },
            { path: 'neu', name: 'settingsSectionsNew', component: view('settings/sections/Section') },
          ]
        },
        */

        { path: 'hersteller/', component: view('settings/manufacturers/Index'),
          children: [
            { path: '', name: 'settingsManufacturers', component: view('settings/manufacturers/Manufacturers'), meta: { isParent: true, keepAlive: false }},
            { path: 'hersteller-:manufacturerID', name: 'settingsManufacturersEdit', component: view('settings/manufacturers/Manufacturer') },
            { path: 'neu', name: 'settingsManufacturersNew', component: view('settings/manufacturers/Manufacturer') },
          ]
        },

        { path: 'rubriken', component: view('settings/sections/Index'),
          children: [
            { path: '', name: 'settingsSections', component: view('settings/sections/Sections'), meta: { isParent: true, keepAlive: false }},
            { path: 'rubrik-:sectionID', name: 'settingsSectionsEdit', component: view('settings/sections/Section') },
            { path: 'neu', name: 'settingsSectionsNew', component: view('settings/sections/Section') },
          ]
        },



        { path: 'lexikon', name: 'catalogOnlineLexicon', component: view('catalog/online/Lexicon'), meta: { suitableDefaultRoute: true, isParent: true} },
        { path: 'neu-am-markt', name: 'catalogOnlineNewProducts', component: view('catalog/online/NewProducts'), meta: { suitableDefaultRoute: true, isParent: true} },
        { path: 'einstellungen', name: 'catalogSettings', component: view('catalog/settings/Index'), meta: { suitableDefaultRoute: true, isParent: true} },
      ]

    },


    // make sure to redirect old "product" paths to the new parent ("/katalog/...")
    { path: '/produkte/(.*)', redirect: to => {
      return '/katalog/produkte/(.*)';
    }},




    // PRODUCTS
    // -------------------------------------------------------------------------
    /*
    { path: '/produkte/', name: 'produkte', component: view('products/Products'), meta: { isParent: true, keepAlive: false } },
    { path: '/produkte/neu/', component: view('products/Product') },
    { path: '/produkte/produkt-:id', name: 'product', component: view('products/Product') },
    { path: '/produkte/produkt-:productID/history', name: 'productHistory', component: view('Logs') },

    { path: '/produkte/history', redirect: '/produkte/aenderungshistorie' },
    { path: '/produkte/aenderungshistorie', name: 'productsHistory', component: view('Logs') },
    { path: '/produkte/reminder', name: 'productsReminder', component: view('Reminder'), meta: { isParent: true } },

    { path: '/produkte/print', name: 'x', component: view('products/PrintProducts'), meta: { isPrintView: true } },
    { path: '/produkte/print-:productID', name: 'y', component: view('products/PrintProducts'), meta: { isPrintView: true } },
    { path: '/produkte/print/:filter', name: 'z', component: view('products/PrintProducts'), meta: { isPrintView: true } },
    */

    // EQUIPMENTS
    // -------------------------------------------------------------------------
    { path: '/geraete-katalog/', name: 'equipmentCatalog', component: view('equipments/Catalog'), meta: { suitableDefaultRoute: true }},
    { path: '/geraete-katalog/neu/', name: 'equipmentCatalogPageNew', component: view('equipments/CatalogPage')},
    { path: '/geraete-katalog/seite-:equipmentCatalogPageID/', name: 'equipmentCatalogPage', component: view('equipments/CatalogPage') },
    { path: '/geraete-katalog/seite-:equipmentCatalogPageID/aenderungshistorie', name: 'equipmentCatalogPageChangeLog', component: view('Logs') },

    { path: '/geraete-katalog/sections/', name: 'equipmentCatalogSections', component: view('equipments/CatalogSections'), meta: { suitableDefaultRoute: true }},
    { path: '/geraete-katalog/sections/:equipmentCatalogSectionID', name: 'equipmentCatalogSection', component: view('equipments/CatalogSection') },
    { path: '/geraete-katalog/sections/neu', name: 'equipmentCatalogSectionNew', component: view('equipments/CatalogSection') },

    { path: '/geraete-katalog/geraete/', name: 'equipments', component: view('equipments/Equipments'), meta: { suitableDefaultRoute: true, isParent: true, keepAlive: false } },
    { path: '/geraete-katalog/geraete/geraet-:equipmentID', name: 'equipment', component: view('equipments/Equipment') },
    { path: '/geraete-katalog/geraete/neu', name: 'equipmentNew', component: view('equipments/Equipment') },

    { path: '/geraete-katalog/geraete-kategorien', name: 'equipmentCategories',component: view('equipments/EquipmentCategories'), meta: { suitableDefaultRoute: true }},
    { path: '/geraete-katalog/geraete-kategorien/neu', name: 'equipmentCategoryNew', component: view('equipments/EquipmentCategory') },
    { path: '/geraete-katalog/geraete-kategorien/:equipmentCategoryID', name: 'equipmentCategory', component: view('equipments/EquipmentCategory') },

    { path: '/geraete-katalog/online-kategorien', name: 'equipmentOnlineCategories', component: view('equipments/EquipmentOnlineCategories'),  meta: { suitableDefaultRoute: true }},

    { path: '/geraete-katalog/aenderungshistorie', name: 'equipmentCatalogChangeLog', component: view('Logs'), meta: { suitableDefaultRoute: true }},

    { path: '/geraete-katalog/anzeigen', name: 'equipmentCatalogAds', component: view('equipments/EquipmentCatalogAds'), meta: { suitableDefaultRoute: true }},


    // KOMMUNIKATIONS-PLATTFORM
    // -------------------------------------------------------------------------
    { path: '/kommunikationsplattform/', name: 'complatDashboard', component: view('communicationPlattform/Dashboard'), meta: { suitableDefaultRoute: true, isParent: true }},

    // newsletter
    { path: '/kommunikationsplattform/newsletter/', name: 'complatNewsletters', component: view('communicationPlattform/newsletter/NewsletterList'), meta: { suitableDefaultRoute: true }},
    // { path: '/kommunikationsplattform/newsletter/empfaenger', name: 'complatNewsletterRecipients', component: view('communicationPlattform/newsletter/NewsletterRecipients') },
    { path: '/kommunikationsplattform/newsletter/:newsletterID', name: 'complatNewsletter', component: view('communicationPlattform/newsletter/NewsletterEdit') },

    // hi print view
    { path: '/kommunikationsplattform/hiPrint', name: 'complatHiPrint', component: view('communicationPlattform/hiPrint/Index'), meta: { suitableDefaultRoute: true }},

    // cooperate view
    { path: '/kommunikationsplattform/cooperate', name: 'complatCooperate', component: view('communicationPlattform/cooperate/Index'), meta: { suitableDefaultRoute: true }},

    // calendar
    { path: '/kommunikationsplattform/kalender', name: 'complatCalendar', component: view('communicationPlattform/calendar/Index'), meta: { suitableDefaultRoute: true }},


    // content pool
    { path: '/kommunikationsplattform/content-pool/', name: 'complatContentPool', component: view('communicationPlattform/contentPool/ContentPool'), meta: { suitableDefaultRoute: true }},
    { path: '/kommunikationsplattform/content-pool/neu', name: 'complatContentPoolContentNew', component: view('communicationPlattform/contentPool/ContentPoolContent') },
    { path: '/kommunikationsplattform/content-pool/content-:contentID', name: 'complatContentPoolContent', component: view('communicationPlattform/contentPool/ContentPoolContent') },

    { path: '/kommunikationsplattform/content-pool/content-:contentID/aenderungshistorie', name: 'complatContentPoolContentChangeLog', component: view('Logs') },
    { path: '/kommunikationsplattform/content-pool/content-:contentID/variant-:contentVariantID/aenderungshistorie', name: 'complatContentPoolContentVariantChangeLog', component: view('communicationPlattform/contentPool/ContentPoolContentElementLogs') },


    // image pool
    { path: '/kommunikationsplattform/bilder-pool/', name: 'complatImagePool', component: view('communicationPlattform/imagePool/ImagesList'), meta: { suitableDefaultRoute: true }},
    { path: '/kommunikationsplattform/bilder-pool/neu', name: 'complatImagePoolImageNew', component: view('communicationPlattform/imagePool/ImagesEdit') },
    { path: '/kommunikationsplattform/bilder-pool/image-:imageID', name: 'complatImagePoolImage', component: view('communicationPlattform/imagePool/ImagesEdit') },

    // image pool - change log
    { path: '/kommunikationsplattform/bilder-pool/aenderungshistorie', name: 'complatImagePoolChangelog', component: view('Logs'), meta: { suitableDefaultRoute: true }},
    { path: '/kommunikationsplattform/bilder-pool/image-:imageID/aenderungshistorie', name: 'complatImagePoolImageChangelog', component: view('Logs') },

    // themenfelder
    { path: '/kommunikationsplattform/themenfelder/', name: 'complatContentPoolTopics', component: view('communicationPlattform/topics/topics'), meta: { suitableDefaultRoute: true }},
    { path: '/kommunikationsplattform/themenfelder/neu', name: 'complatContentPoolTopicNew', component: view('communicationPlattform/topics/topic') },
    { path: '/kommunikationsplattform/themenfelder/themenfeld-:topicID', name: 'complatContentPoolTopic', component: view('communicationPlattform/topics/topic') },

    // settings
    { path: '/kommunikationsplattform/einstellungen', name: 'complatContentPoolSettings', component: view('communicationPlattform/settings/index'), meta: { suitableDefaultRoute: true }},


    // MARKETING COCKPIT
    // -------------------------------------------------------------------------
    { path: '/marketing-cockpit', name: 'marketingCockpit', redirect: { name: 'calendar'}, meta: { suitableDefaultRoute: true }},
    { path: '/marketing-cockpit/kalender/', name: 'calendar', component: view('calendar/Calendar'), meta: { suitableDefaultRoute: true, isParent: true, keepAlive: false } },
    { path: '/marketing-cockpit/newsletter/', name: 'newsletter', component: view('newsletter/newsletter'), meta: { suitableDefaultRoute: true }},
    { path: '/marketing-cockpit/social-media/', name: 'socialMedia', component: view('socialMedia/index'), meta: { suitableDefaultRoute: true }},


    // SETTINGS
    // -------------------------------------------------------------------------
    // { path: '/einstellungen/', name: 'settings', component: view('settings/Settings') },
    { path: '/einstellungen/', name: 'settings', redirect: { name: 'users'}, meta: { suitableDefaultRoute: true }},
    { path: '/einstellungen/email-templates', name:'settingsEmailTemplates', component: view('settings/email/Templates'), meta: { suitableDefaultRoute: true }},
    { path: '/einstellungen/email-templates/neu', component: view('settings/email/Template') },
    { path: '/einstellungen/email-templates/template-:templateID', component: view('settings/email/Template') },
    { path: '/einstellungen/labels', name: 'settingsLabels', component: view('settings/Labels'), meta: { isParent: true, suitableDefaultRoute: true }},
    { path: '/einstellungen/monitoring', name: 'settingsInterfacesMonitoring', component: view('settings/InterfacesDashboard/Index'), meta: { suitableDefaultRoute: true, isParent: false } },

    // USER
    // -------------------------------------------------------------------------
    { path: '/einstellungen/benutzer/', name: 'users', component: view('users/Users'), meta: { suitableDefaultRoute: true, isParent: true } },
    { path: '/einstellungen/benutzer/benutzer-:userID', name: 'userEdit', component: view('users/User') },
    { path: '/einstellungen/benutzer/neu/', name: 'userNew', component: view('users/User') },
    { path: '/einstellungen/benutzer-berechtigungen/', name: 'userPermissions', component: view('users/Permissions'), meta: { suitableDefaultRoute: true }},
    { path: '/account', component: view('My-account'), meta: { isParent: true } },


    // LOGIN
    // -------------------------------------------------------------------------
    { path: '/login', name: 'login', component: view('Login'), meta: { transition: 'login-fade' } },
    { path: '/recover', name: 'recover', component: view('Recover') },
    { path: '/login/recover', component: view('Recover') },


    // LOGOUT
    // -------------------------------------------------------------------------
    { path: '/logout', name: 'logout', component: view('Login') },


    // USER ROLE: APOTHEKE
    // -------------------------------------------------------------------------
    { path: '/katalog/stammdaten', name: 'apoHome', component: view('userRoleSites/Apotheke/Index') },

    { path: '/content/:catID', component: view('userRoleSites/Apotheke/EditMutation') },
    { path: '/voucher/', component: view('userRoleSites/Apotheke/EditVoucher') },

    // { path: '/content/:siteCatalogID/:catID', component: view('userRoleSites/Apotheke/EditMutation') },
    // { path: '/voucher/:siteCatalogID/', component: view('userRoleSites/Apotheke/contentVoucher') },

    { path: '/apopoint/cms', name: 'apoCMS', component: view('userRoleSites/Apotheke/ApopointCMS') },


    // USER ROLE: INDUSTRIEPARTNER
    // -------------------------------------------------------------------------
    { path: '/druckfreigaben', name: 'druckfreigaben', component: view('userRoleSites/Industriepartner/printApprovements') },
    { path: '/inhalte', name: 'inhalte', component: view('userRoleSites/Industriepartner/contents') },


    // MARKETING COCKPIT
    // -------------------------------------------------------------------------
    { path: '/marketing-cockpit/:id', name: 'marketingCockpit' },

    // CALENDAR EXTERN
    // -------------------------------------------------------------------------
    { path: '/embedded-calendar/:id', name: 'calendarIframe', component: view('calendar/CalendarIframe') },

    // ALL OTHER -> NOT FOUND PAGE
    // -------------------------------------------------------------------------
    { path: '*', component: view('NotFound') }

];


// Asynchronously load view (Webpack Lazy loading compatible)
// https://github.com/vuejs/vue-router/issues/215
// -----------------------------------------------------------------------------
function view(name) {

    return function(resolve) {
        require(['@/components/' + name + '.vue'], resolve);
    }

}

const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    base: __dirname,
    saveScrollPosition: true,
    scrollBehavior,
    routes
});

export default router;
